module.exports = __webpack_public_path__ + "img/no-cert.6ae9bfb4.png";